import Box, { BoxProps } from "@mui/material/Box";
import { forwardRef } from "react";

const FlexBox = forwardRef<HTMLDivElement, BoxProps>(function FlexBox(props, ref) {
  return <Box ref={ref} display="flex" {...props} />;
});

export default FlexBox;
